var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.45 11.738a1.14 1.14 0 1 1 0 2.281 1.14 1.14 0 0 1 0-2.281"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M23.45 9.446V1.45h-17v8.001M6.45 28.447h17v-11h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.511 23.451H2.573c-.62 0-1.123-.5-1.123-1.118V10.569a1.12 1.12 0 0 1 1.123-1.118h24.753c.62 0 1.124.501 1.124 1.118v11.764a1.12 1.12 0 0 1-1.124 1.118h-3.938M20.881 20.875H9.452M20.881 24.6H9.452"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinter);
export default ForwardRef;